<template>
  <b-form enctype="multipart/form-data" @submit.prevent="$emit('submit')">
    <h2 class="pb-1">Horas de Consultoría y Capacitación</h2>

    <table class="table TablaModulosEdicionPrecios">
      <thead valign="middle">
        <th>&nbsp;</th>
        <th v-for="plan in planes" :key="plan.id">{{ plan.id }}. {{ plan.nombre }}</th>
      </thead>
      <tbody>
        <tr>
          <td>Consultoría</td>
          <td v-for="plan in planes" :key="plan.id">
            <b-form-input
              v-if="moduloPlanHorasNormalizados[plan.id]"
              v-model="moduloPlanHorasNormalizados[plan.id].numHorasConsultoria"
              type="number"
              placeholder="Número de horas Consultoría"
            />
          </td>
        </tr>
        <tr>
          <td>Capacitación</td>
          <td v-for="plan in planes" :key="plan.id">
            <b-form-input
              v-if="moduloPlanHorasNormalizados[plan.id]"
              v-model="moduloPlanHorasNormalizados[plan.id].numHorasCapacitacion"
              type="number"
              placeholder="Número de horas Capacitación"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <botonera-edicion url-cancelar="/modulos" />
  </b-form>
</template>

<script>
export default {
  props: {
    moduloPlanHorasNormalizados: Object,
    planes: Array,
  },
};
</script>
